export default function Menu() {
  const columns = [
    { label: "IP", className: "menuExchange" },
    { label: "ID", className: "menuSymbol" },
    { label: "DEVICE", className: "menuSymbol" },
    { label: "LOGIN-IN-DATE", className: "menuLtt" },
    { label: "LOGOUT-IN-DATE", className: "menuLtt" },
    { label: "DATE", className: "menuLtt" },
  ];

  return (
    <div className="menuContainer primary white">
      {columns.map((c, i) => (
        <div key={i} className={c.className}>
          {c.label}
        </div>
      ))}
    </div>
  );
}
